import React, { useCallback, useState } from 'react';
import Button from '../../../../styled/Button';
import Distance from '../../../../styled/Distance';
import { CartIcon } from '../../../../styled/Icon';
import useBuyButton from './useBuyButton';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';
import AlertInactive from '../../../../styled/AlertInactive';
import Text from '../../../../styled/Text';
import { Container, DropDownContainer } from '../../../../styled/BuyButton/wrappers';
import Link from '../../../../Router/Link';
import { StyledLink } from '../../../../styled/Link';
import QuantityDropdown from '../../../../components-legacy/QuantityDropdown';

const BuyButton = () => {
  const { variantId, closestVariantUrl } = useContext(ProductContext);
  const [quantity, setQuantity] = useState(1);
  const { disabled, message, onAddToCart, isActive, showQuantityDropdown } =
    useBuyButton(variantId);

  const onSetQuantity = useCallback(
    (quantity) => {
      if (isNaN(quantity)) {
        quantity = 1;
      }
      return setQuantity(quantity);
    },
    [setQuantity],
  );

  return (
    <div className="hidden-lt-md">
      {message && (
        <>
          {!isActive ? (
            <AlertInactive tone="inactive">
              {message}
              <Text weight="regular">
                Se liknande eller produkter ur samma kategori längre ner på sidan.
              </Text>
              {closestVariantUrl && (
                <>
                  <Distance size="1" />
                  <Link
                    href={closestVariantUrl}
                    Component={StyledLink}
                    title="Närmsta möjliga variant">
                    Se närmaste variant här
                  </Link>
                </>
              )}
            </AlertInactive>
          ) : (
            <Text>{message}</Text>
          )}
          <Distance size="3" />
        </>
      )}
      {showQuantityDropdown ? (
        <Container>
          <DropDownContainer>
            <QuantityDropdown disabled={disabled} quantity={quantity} onChange={onSetQuantity} />
          </DropDownContainer>
          <Button
            disabled={disabled}
            large
            onClick={() => onAddToCart(quantity)}
            rounded
            size="large"
            tone="forward"
            type="button">
            {!isActive ? (
              'Ej tillgänglig'
            ) : (
              <>
                <CartIcon className="m-r-half" /> Köp{' '}
              </>
            )}
          </Button>
        </Container>
      ) : (
        <Button
          disabled={disabled}
          full
          onClick={() => onAddToCart(quantity)}
          rounded
          size="large"
          tone="forward"
          type="button">
          {!isActive ? (
            'Ej tillgänglig'
          ) : (
            <>
              <CartIcon className="m-r-half" /> Köp{' '}
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default BuyButton;
